class FormatHelpers {

    formatFloat(pEvent, pMaxIntDigits, pPrecision, allowNegative = false)
    {
        let numericValue = pEvent.target.value;

        let regex = new RegExp(`^\\d{0,${pMaxIntDigits}}(\\.\\d{0,${pPrecision}})?$`);
        if (allowNegative) regex = new RegExp(`^[-]?\\d{0,${pMaxIntDigits}}(\\.\\d{0,${pPrecision}})?$`);

        // Check if the input value matches the format
        if (!regex.test(numericValue)) 
        {
        numericValue = numericValue.slice(0, -1) + '.' + numericValue.slice(-1);
        if (!regex.test(numericValue))
        {
            numericValue = numericValue.slice(0, numericValue.length - 2);
        }
        }

        pEvent.target.value = numericValue;
        return numericValue;
    }

    formatDollars(pEvent, pMaxIntDigits, pPrecision = 2, allowNegative = false) {
        const inputEl = pEvent.target;
        const oldValue = inputEl.value;
        const oldCursor = inputEl.selectionStart;

        // Allow only these characters
        let numericString = oldValue.replace(/[^0-9.\-$]/g, '');

        const isNegative = allowNegative && numericString.startsWith('-');

        // Remove formatting symbols for raw number parsing
        let raw = numericString.replace(/\$/g, '').replace(/-/g, '');

        // Split integer and decimal parts using dot
        let [integerPart = '', fractionalPart = ''] = raw.split('.');

        // Enforce digit limits
        integerPart = integerPart.slice(0, pMaxIntDigits);
        fractionalPart = fractionalPart.slice(0, pPrecision);

        // Thousand separators
        const intWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        // Rebuild formatted value
        let formatted = '';
        if (isNegative) formatted += '-';
        if (/\d/.test(numericString) || numericString.includes('$')) formatted += '$';
        formatted += intWithCommas;
        if (pPrecision > 0 && (fractionalPart.length > 0 || numericString.includes('.'))) {
            formatted += '.' + fractionalPart;
        }

        // Remember cursor placement
        const digitsBeforeCursor = oldValue.slice(0, oldCursor).replace(/[^0-9]/g, '').length;
        let cursor = 0, digitsSeen = 0;
        for (; cursor < formatted.length; cursor++) {
            if (/\d/.test(formatted[cursor])) {
                digitsSeen++;
            }
            if (digitsSeen >= digitsBeforeCursor) {
                cursor++;
                const decimalIndex = oldValue.indexOf('.');
                if (formatted.endsWith('.') ||  formatted.endsWith('$') || (decimalIndex !== -1 && oldCursor > decimalIndex)) cursor++
                break;
            }
        }
        inputEl.value = formatted;
        inputEl.setSelectionRange(cursor, cursor);

        return formatted;
    }

    TrimSymbols(val) {
        val = (val && val.trim()) ? val.replace(/,/g, '').replace(/\$/g, '') : '';
        return val
    }

    onPhonePaste(e)
    {
        e.preventDefault();
        let digits = e.clipboardData.getData('text').replace(/\D/g, '');

        if (digits.length > 10) {
            digits = digits.slice(-10);
        }

        let formatted = digits;
        if (digits.length > 0) {
            formatted = '(' + digits.substring(0, Math.min(3, digits.length)) + ')';
        }
        if (digits.length >= 4) {
            formatted += ' ' + digits.substring(3, Math.min(6, digits.length));
        }
        if (digits.length >= 7) {
            formatted += '-' + digits.substring(6, 10);
        }
        
        e.target.value = formatted;
    }

}
export default new FormatHelpers();